import bleExtensionMessageType from "../../consts/bleExtensionMessageType";
import BleDeviceServiceCharacteristic from "./BleDeviceServiceCharacteristic";
import { IBleDeviceServiceCharacteristicsResponse, IBleDeviceServiceCharacteristic} from "./Models";
import { sendMessageAsync } from "./extensionUtils";

export default class BleDeviceService {
    private characteristics: { [key: string]: BleDeviceServiceCharacteristic }
    private uuid: string
    private deviceId: string;

    constructor(deviceId: string, uuid: string) {
        this.uuid = uuid;
        this.deviceId = deviceId;
        this.characteristics = {};
    }

    async getServiceCharacteristics(): Promise<IBleDeviceServiceCharacteristic[]> {
        const response = await sendMessageAsync<IBleDeviceServiceCharacteristicsResponse>({ type: bleExtensionMessageType.characteristicsForService, service: this.uuid, id: this.deviceId });

        if (!response?.characteristics) return [];

        response.characteristics.forEach((characteristic) => {
            const { id, properties } = characteristic;
            const characteristicUuid = id.toUpperCase();

            if (!this.characteristics[characteristicUuid]) {
                this.characteristics[characteristicUuid] = new BleDeviceServiceCharacteristic(this.deviceId, this.uuid, characteristicUuid);
            }
        })

        return response.characteristics;
    }

    async getCharacteristic(uuid: string) {
        let characteristic = this.#getCharacteristicInternal(uuid);
        if(characteristic) {
            return characteristic;
        }

        await this.getServiceCharacteristics();

        characteristic = this.#getCharacteristicInternal(uuid);
        if(characteristic) {
            return characteristic;
        } else {
            throw new Error(`No exists characteristic: [${uuid}]`)
        }
    }

    stopReadingData() {
        Object.values(this.characteristics).forEach(characteristic => characteristic.stopReading());
    }

    #getCharacteristicInternal(characteristicUuid: string) {
        return this.characteristics[characteristicUuid.toUpperCase()];
    }
}